import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ReactComponent as BackButtonIcon } from 'core/assets/images/V2/icons/BackButton.svg';
import { Flex, Text } from 'core/ui/atoms';

const NavigationHeader = ({ title, showNavigation = true, backNavigate }) => {
  const history = useHistory();
  const handleGoBack = () => backNavigate ? backNavigate() : history.goBack();

  return (
    <Container
      direction='row'
      justifyContent={showNavigation ? 'flex-start' : 'center' }
      alignItems='center'
      gap='16px'>
      {showNavigation && <Caret onClick={handleGoBack} />}
      <Title>{title}</Title>
    </Container>
  );
};

NavigationHeader.propTypes = {
  title: PropTypes.string.isRequired,
  showNavigation: PropTypes.bool,
  backNavigate: PropTypes.func,
};

const Container = styled(Flex)`
  padding-top: 20px;
  padding-bottom: 16px;
`;

const Caret = styled(BackButtonIcon)`
  display: inline-block;
  font-size: x-large;
  transition: transform 0.25s ease-in-out;
  transform-style: preserve-3d;
  margin-left: 20px;
`;

const Title = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 30px;
  font-weight: 400;
  line-height: 0px;
  width: 100%;
  text-align: center;
  margin: 0px;
  line-height: 32px;
  color: ${(p) => p.theme.colors.primaryV2};
  ${(p) => p.theme.max('md')`
    width: 70%;
  `}
`;

export default NavigationHeader;
